import React from "react";
import "./Greeting.css";
import SocialMedia from "../../components/socialMedia/SocialMedia";
import Button from "../../components/button/Button";
import { greeting } from "../../portfolio";
import {Fade} from "react-reveal";
import emoji from "react-easy-emoji";

export default function Greeting() {
  return (
    <Fade bottom duration={1000} distance="40px">
    <div className="greet-main" id="greeting">
      <div className="greeting-main">
        <div className="greeting-text-div">
          <div>
            <h1 className="greeting-text">
              {" "}
              {greeting.title}
              {" "}
              <span className="wave-emoji">{emoji("👋")}</span>
            </h1>
            <p className="greeting-text-p subTitle">{greeting.subTitle}</p>
            <p className="greeting-text-p subTitle">I'm a 5th year B.S./M.S. student in the <a href={"https://www.cs.washington.edu"}>Paul G. Allen School of Computer Science & Engineering</a> at the University of Washington, Seattle.
            </p>
            <p className="greeting-text-p subTitle">
              I believe that Computer Science can have a broader impact than just engineering and software. My research focuses on building infrastructures that support <i>in silico experiments</i> for studying the system-level dynamics of complex, nonlinear biological networks.
              My most recent work proposed a scalable method for test-driven development on biochemical models and was published and presented at ISGSB 2020.
              I am advised by Dr. <a href={"https://escience.washington.edu/people/joseph-hellerstein/"}>Joseph Hellerstein</a>, and I'm very fortunate to have collaborated with researchers in Dr. <a href={"https://bioe.uw.edu/portfolio-items/sauro/"}>Herbert Sauro</a>'s <a href={"https://www.sys-bio.org"}>
              Predictive Sys-Bio Lab</a>.
            </p>
            <p className="greeting-text-p subTitle">
              3/18/2021: I submitted and defended my undergraduate honors thesis <i>Testing Dynamical Systems: An Application To Systems Biology</i>, and received my bachelor's degree with honors!
            </p>
            <p className="greeting-text-p subTitle">
              4/2/2021: I officially started my internship at NVIDIA!
            </p>
            <p className="greeting-text-p subTitle">
              6/7/2021: I accepted an offer to join NVIDIA next year after graduation! I'll be working as a Systems Software Engineer in the AI Infrastructure team for Autonomous Vehicles at NVIDIA's Redmond office.
            </p>
            <p className="greeting-text-p subTitle">
              7/12/2021: I officially started my internship at Adobe!
            </p>
            <SocialMedia />
            <div className="button-greeting-div">
              <Button text="Contact me" href="#contact" />
              <Button text="See my resume (Last updated: Sep 2020)" newTab={true} href={greeting.resumeLink} />
            </div>
          </div>
        </div>
        <div className="greeting-image-div">
          <img alt="sma" src={require("../../assets/images/circle-cropped.png")} width="414" height="414"/>
        </div>
      </div>
    </div>
    </Fade>
  );
}
